let geometryTypes = require('./../../modules_constants/geometry/types');

module.exports = geometryTypes;